import React from 'react';
import { SelectInput, TextInput, required } from 'react-admin';
import {
  Grid,
  Typography,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel
} from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatAlignCenter from '@material-ui/icons/FormatAlignCenter';
import FormatAlignLeft from '@material-ui/icons/FormatAlignLeft';
import FormatAlignRight from '@material-ui/icons/FormatAlignRight';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import {
  fontTypes,
  fontSizes,
  textDirection,
  textPosition,
  watermarkCheckboxInclude
} from './DocumentWatermarkLookups';
import { Field } from 'react-final-form';
import CheckBoxField from '../../core/components/CheckBoxField';
import GridPopover from '../../core/components/grid/GridPopover';
import { FormSpy } from 'react-final-form';
import DocumentWatermarkColorPicker from './DocumentWatermarkColorPicker';
import { fieldLengthValidator } from '../../core/utils/index';
import {
  convertColorToHex,
  convertFontColorFromHexToString
} from './DocumentWatermarkUtils';
const styles = {
  headerContainer: {
    paddingTop: '0px !important'
  },
  formCheckBox: {
    marginTop: '19px'
  },
  label: {
    fontSize: '14px',
    color: '#757575',
    paddingLeft: '2px',
    transform: 'translate(0px, 5px)'
  },
  fontSizeInput: {
    minWidth: '80px'
  },
  alignmentButton: {
    width: '32px',
    height: '32px',
    marginTop: '8px',
    marginBottom: '14px'
  },
  boldItalicButtons: {
    width: '32px',
    height: '32px',
    marginTop: '8px',
    marginBottom: '14px',
    marginLeft: '8px',
    // preventing two toggle buttons from "sticking together" when both are selected
    '&.MuiToggleButton-root.Mui-selected+.MuiToggleButton-root.Mui-selected': {
      marginLeft: '8px',
      borderLeft: 'solid 1px rgba(0, 0, 0, 0.12)'
    }
  },
  colorPickerButtonBlack: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#000000'
  },
  colorPickerButtonRed: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#FF0000'
  },
  colorPickerButtonBlue: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#0000FF'
  },
  colorPickerButtonOrange: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#FFA500'
  },
  colorPickerButtonGreen: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#00FF00'
  },
  colorPickerButtonGrey: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    transform: 'translate(15px, -3px)',
    padding: '2px',
    boxShadow: 'inset 0 0 0 1.5px white',
    backgroundColor: '#A0A0A0'
  },
  colorPickerInsideButton: {
    width: '32px',
    height: '32px',
    minWidth: '32px', // required in order to override Button's default settings
    padding: '2px'
  },
  colorPickerPopup: {
    width: '108px',
    minWidth: '32px', // required for override
    padding: '2px',
    zIndex: '100',
    '& > div': {
      maxHeight: '250px' // override
    }
  },
  textArea: {
    minWidth: '288px',
    maxWidth: '288px',
    maxHeight: '300px',
    marginTop: '4px'
  },
  toggleContainer: {
    backgroundColor: 'transparent'
  },
  customButtonGrid: {
    float: 'right',
    display: 'inline-block',
    marginTop: '15px'
  },
  sizeGrid: {
    display: 'inline-block'
  }
};

const watermarkProfileNameLength = 150;
const watermarkTextLength = 150;

class DocumentWatermarkSummary extends React.Component {
  defineColorPickerButtonClass = (classes, fontColor) => {
    let colorPickerButtonClass;
    switch (fontColor) {
      case 'RED':
        colorPickerButtonClass = classes.colorPickerButtonRed;
        break;
      case 'BLUE':
        colorPickerButtonClass = classes.colorPickerButtonBlue;
        break;
      case 'ORANGE':
        colorPickerButtonClass = classes.colorPickerButtonOrange;
        break;
      case 'GREEN':
        colorPickerButtonClass = classes.colorPickerButtonGreen;
        break;
      case 'GREY':
        colorPickerButtonClass = classes.colorPickerButtonGrey;
        break;
      default:
        colorPickerButtonClass = classes.colorPickerButtonBlack;
    }
    return colorPickerButtonClass;
  };

  render() {
    const { classes, variant, record } = this.props;

    const checkboxFields = watermarkCheckboxInclude.map(field => (
      <Field
        key={field.fieldName} // console error fix, all fields must have a unique key
        name={field.fieldName}
        component={CheckBoxField}
        label={'Include ' + field.label}
        variant={variant}
        type="checkbox"
        initialValue={
          record[`${field.fieldName}`] ? record[`${field.fieldName}`] : false
        }
      />
    ));

    return (
      <FormSpy>
        {formProps => {
          return (
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.headerContainer}>
                <Typography variant="h5">Watermark Settings</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3}>
                <TextInput
                  source="profileName"
                  label="Watermark Profile Name"
                  validate={[
                    required(),
                    fieldLengthValidator(watermarkProfileNameLength)
                  ]}
                  options={{ autoComplete: 'off' }}
                  variant={variant}
                />
                <TextInput
                  multiline
                  source="watermarkText"
                  label="Watermark Text"
                  validate={fieldLengthValidator(watermarkTextLength)}
                  variant="standard"
                  rows={8}
                />
                {checkboxFields} {/* rendering "Include ..." checkboxes */}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3}>
                <SelectInput
                  source="font"
                  label="Font Type"
                  variant="standard"
                  choices={fontTypes}
                  optionValue="id"
                />
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    className={classes.sizeGrid}
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                  >
                    <SelectInput
                      source="fontSize"
                      label="Font Size"
                      variant="standard"
                      className={classes.fontSizeInput}
                      choices={fontSizes}
                    />
                  </Grid>
                  <Grid
                    className={classes.customButtonGrid}
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                  >
                    <Field name="fontColor">
                      {({ input: { value, onChange } }) => {
                        return (
                          <GridPopover
                            id="fontColorButton"
                            classes={{
                              button: this.defineColorPickerButtonClass(
                                classes,
                                value
                              ),
                              paper: classes.colorPickerPopup
                            }}
                            popoverContent={
                              <DocumentWatermarkColorPicker
                                classes={classes}
                                onChangeColorPicker={event =>
                                  onChange(
                                    convertFontColorFromHexToString(
                                      convertColorToHex(
                                        event.currentTarget.style
                                          .backgroundColor
                                      )
                                    )
                                  )
                                }
                              />
                            }
                          />
                        );
                      }}
                    </Field>

                    <Field name="isBoldSelected">
                      {({ input: { value, onChange, name } }) => (
                        <ToggleButton
                          className={classes.boldItalicButtons}
                          name={name}
                          value="bold"
                          selected={value}
                          onChange={() => onChange(!value)}
                        >
                          <FormatBoldIcon />
                        </ToggleButton>
                      )}
                    </Field>
                    <Field name="isItalicSelected">
                      {({ input: { value, onChange, name } }) => (
                        <ToggleButton
                          className={classes.boldItalicButtons}
                          name={name}
                          value="italic"
                          selected={value}
                          onChange={() => onChange(!value)}
                        >
                          <FormatItalicIcon />
                        </ToggleButton>
                      )}
                    </Field>
                  </Grid>
                </Grid>
                {/* ToggleButtonGroup has no true label property */}
                <FormLabel className={classes.label}>
                  Horizontal Alignment
                  <br />
                </FormLabel>
                <Field name="horizontalAlignment">
                  {({ input: { value, onChange, name } }) => (
                    <ToggleButtonGroup
                      name={name}
                      exclusive
                      // this is a required field but such validation is not possible so we always have at least one option selected
                      value={value}
                      onChange={(event, alignment) => onChange(alignment)}
                      className={classes.toggleContainer}
                    >
                      <ToggleButton
                        value="LEFT_JUSTIFIED"
                        className={classes.alignmentButton}
                      >
                        <FormatAlignLeft />
                      </ToggleButton>
                      <ToggleButton
                        value="CENTERED"
                        className={classes.alignmentButton}
                      >
                        <FormatAlignCenter />
                      </ToggleButton>
                      <ToggleButton
                        value="RIGHT_JUSTIFIED"
                        className={classes.alignmentButton}
                      >
                        <FormatAlignRight />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                </Field>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginTop: '10px' }}
                >
                  {/* RadioGroup has no true label property */}
                  <FormLabel className={classes.label}>
                    Watermark Display
                    <br />
                  </FormLabel>
                  <Field name="watermarkDisplay">
                    {({ input: { value, onChange, name } }) => (
                      <RadioGroup
                        row
                        name={name}
                        value={value}
                        onChange={() =>
                          onChange(
                            value === 'direction' ? 'position' : 'direction'
                          )
                        }
                        style={{ marginBottom: '10px' }}
                      >
                        <FormControlLabel
                          value="direction"
                          control={<Radio />}
                          label="Direction"
                        />
                        <FormControlLabel
                          value="position"
                          control={<Radio />}
                          label="Position"
                        />
                      </RadioGroup>
                    )}
                  </Field>
                </Grid>
                {formProps.values.watermarkDisplay === 'direction' ? (
                  <React.Fragment>
                    <SelectInput
                      source="alignment"
                      label="Watermark Text Direction"
                      variant="standard"
                      style={{ height: '60px' }}
                      choices={textDirection}
                      optionValue="id"
                      validate={[required()]} // doesn't perform real validation, but it puts an asterisk in the label
                    />
                    {formProps &&
                    formProps.values &&
                    formProps.values.alignment === 'REPEATING_DIAGONAL' ? (
                      <></>
                    ) : (
                      <Field
                        name="stretched"
                        component={CheckBoxField}
                        label="Stretch text to fit page"
                        variant={variant}
                        type="checkbox"
                      />
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <SelectInput
                      source="orientation"
                      label="Watermark Text Position"
                      variant="standard"
                      choices={textPosition}
                      optionValue="id"
                      validate={[required()]} // doesn't perform real validation, but it puts an asterisk in the label
                    />
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          );
        }}
      </FormSpy>
    );
  }
}

export default withStyles(styles)(DocumentWatermarkSummary);
